export default __webpack_public_path__ + "static/media/Snd_e5.e1de5d99.mp3";